import { styled } from '@mui/material';
import React__default from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { ButtonName } from '../../theme/componentNames.js';
import { createResponsiveStyles } from '../../theme/util.js';

const QuantityControlContainer = styled('div', { label: 'QuantityControlContainer' })(({ theme }) => {
    var _a;
    const cssStyleOverrides = createResponsiveStyles(theme, (_a = theme.componentCSSOverrides) === null || _a === void 0 ? void 0 : _a[ButtonName.CheckoutQuantityControl]);
    const btnStyles = Object.assign({ backgroundColor: theme.vars.palette.tertiary.main, color: theme.vars.palette.tertiary.contrastText }, cssStyleOverrides);
    return Object.assign(Object.assign({}, btnStyles), { display: 'flex', width: 80, height: 23, alignItems: 'center', borderRadius: 999, fontSize: 14, button: {
            padding: 0,
        }, '.control': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 'inherit',
            outline: 'none',
            border: 'none',
            color: 'inherit',
            backgroundColor: 'transparent',
            transitionProperty: 'transform',
            transitionDuration: '.6s',
            '&:active': {
                transform: 'scale(.9)',
            },
            '&.minus': {
                paddingLeft: 8,
                minWidth: 'unset',
                margin: 0,
                height: 'auto',
            },
            '&.add': {
                paddingRight: 8,
                minWidth: 'unset',
                margin: 0,
                height: 'auto',
            },
        }, '.count': {
            cursor: 'default',
            fontSize: 'inherit',
            fontWeight: 600,
            flex: 1,
            textAlign: 'center',
            color: 'inherit',
        }, '&.large': {
            width: 96,
            height: 30,
            fontSize: 14,
            '.control': {
                '&.minus': {
                    paddingLeft: '10px',
                },
                '&.add': {
                    paddingRight: '10px',
                },
            },
            [theme.breakpoints.down('sm')]: {
                width: 68,
                height: 27,
                '.control': {
                    '&.minus': {
                        paddingLeft: '6px',
                    },
                    '&.add': {
                        paddingRight: '6px',
                    },
                },
            },
        } });
});
const QuantityControl = ({ large = false, count, backgroundColor, onAddClick, onMinusClick, disabled = false, responsiveBackgroundColor, }) => {
    return (React__default.createElement(QuantityControlContainer, { className: large ? 'large' : '', sx: (theme) => ({
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            backgroundColor,
            [theme.breakpoints.down('sm')]: {
                backgroundColor: responsiveBackgroundColor || backgroundColor,
            },
        }), onClick: (e) => {
            if (disabled) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        } },
        React__default.createElement("button", { onClick: (e) => onMinusClick(e), className: "minus control", "aria-label": "Decrement quantity" },
            React__default.createElement(RemoveRoundedIcon, { sx: { fontSize: 16 } })),
        React__default.createElement("div", { className: "count" }, count),
        React__default.createElement("button", { onClick: (e) => onAddClick(e), className: "add control", "aria-label": "Increment quantity" },
            React__default.createElement(AddRoundedIcon, { sx: { fontSize: 16 } }))));
};

export { QuantityControl };
//# sourceMappingURL=QuantityControl.js.map
